import { render, staticRenderFns } from "./GradingEffect.vue?vue&type=template&id=f4a3c4d8&scoped=true&"
import script from "./GradingEffect.vue?vue&type=script&lang=js&"
export * from "./GradingEffect.vue?vue&type=script&lang=js&"
import style0 from "./GradingEffect.vue?vue&type=style&index=0&id=f4a3c4d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a3c4d8",
  null
  
)

export default component.exports